const namespace = '[Google Classroom]';

export const CLASSROOM_GET_CLASSES = `${namespace} CLASSROOM GET CLASSES`;
export const CLASSROOM_CHANGE_CLASS = `${namespace} CLASSROOM CHANGE CLASS`;
export const CLASSROOM_RESET_LOAD_STATE = `${namespace} CLASSROOM RESET LOAD STATE`;
